import { render, staticRenderFns } from "./StatusComponent.vue?vue&type=template&id=2e6e2f49&scoped=true&"
import script from "./StatusComponent.vue?vue&type=script&lang=js&"
export * from "./StatusComponent.vue?vue&type=script&lang=js&"
import style0 from "./StatusComponent.vue?vue&type=style&index=0&id=2e6e2f49&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e6e2f49",
  null
  
)

export default component.exports